import { useApiGetProposalsByGroup } from '@repo/api-codegen';
import { useMemo } from 'react';
import type { ProposalsListModalProps } from './ProposalsListModal';
import { ProposalsListModal } from './ProposalsListModal';

export type ProposalsGroupRendererProps = Pick<
	ProposalsListModalProps,
	'mode'
> & {
	proposalGroup: string;
};

export function ProposalsGroupRenderer({
	proposalGroup,
	mode,
}: ProposalsGroupRendererProps) {
	const { data } = useApiGetProposalsByGroup({
		pathParams: { proposalGroup },
	});

	const filteredData = useMemo(
		() => data?.filter((proposal) => proposal.status !== 'rejected'),
		[data]
	);

	if (!filteredData) {
		return null;
	}

	return <ProposalsListModal data={filteredData} mode={mode} />;
}
